
import low from 'lowdb'
import LocalStorage from 'lowdb/adapters/LocalStorage'

const adapter = new LocalStorage(`zx-shop`)
const db = low(adapter)

db.defaults({
  sys: {},
  route: []
}).write()

/**
 * 设置路由
 */
db.setRoute = (e, params) => {
  let route = db.get('route');
  let path = { 'path': e.$route.path };
  if (route.find(path).value()) {
    route.find(path).assign(params).write();
  } else {
    route.push(Object.assign(path, params)).write();
  }
}

/**
 * 取字段
 */
db.getRouteField = (e, value) => {
  let route = db.get('route');
  let path = { 'path': e.$route.path };
  // 默认
  let v = route.find(path).value();
  if (v) return v[value];
}

export default db


// WEBPACK FOOTER //
// ./src/utils/db.js